import React, { Component } from 'react';
import { Field, Form, reduxForm, getFormValues } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { connect } from 'react-redux';
import { Link, Prompt } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import Paper from 'material-ui/Paper';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';

import RenderDialog from '../../../helpers/RenderDialog';
import renderTextField from '../../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../../helpers/ValidationHelper';
import { removeWhiteSpace } from '../../../helpers/Util';

import RenderConfirmationTimeoutDialog from '../../../helpers/RenderConfirmationTimeoutDialog';

import getCustomerGroups from '../../../actions/getCustomerGroups';
import getCustomers from '../../../actions/getCustomers';
import searchAllPages from '../../../actions/searchAllPages';

import Layout from '../../Layout';
import addEditCustomerGroup from '../../../actions/addEditCustomerGroup';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
  },
  content: {
    flex: '1 0 auto',
  },
  paperStyle: {
    width: '30%',
    height: '100%',
    display: 'inline-block',
    margin: 20,
    marginTop: '13vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15,
    textAlign: 'center',
    alignItems: 'center',
    width: '45%',
    marginLeft: '35%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonSize: {
    minWidth: 123,
    height: 36
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  radioGroup: {
    marginTop: '4%',
    marginLeft: '12%',
    textAlign: 'left',
    opacity: '0.7'
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  headerTitleStyle: {
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

const validate = (values) => {
  const errors = validationHelper.validateRequired(['customerGroupName', 'customerGroupDesc', 'customerGroupType'], values);
  const lengthValidation = [
    { field: 'customerGroupName', label: 'Customer Group Name', value: values.customerGroupName, min: 0, max: 100 },
    { field: 'customerGroupDesc', label: 'customer Group Description', value: values.customerGroupDesc, min: 0, max: 250 },
    { field: 'customerGroupType', label: 'customer Group Type', value: values.customerGroupType, min: 0, max: 30 }
  ];
  validationHelper.validateLength(errors, lengthValidation);
  return errors;
};

class AddEditCustomerGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidNameUsed: false,
      open: false,
      openDialog: false,
      saving: false,
      showPrompt: <div />,
      message: null
    };
  }

  componentDidMount() {
    this.shouldPromptExist();
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.data.formValues !== this.props.data.formValues)
      && (prevProps.dirty !== this.props.dirty)) {
      this.shouldPromptExist();
    }
  }

  checkCustomerGroupName = (event) => {
    const { exclusionaryNames } = this.props.data.config;
    let val = '';
    if ('customerGroupName' in event) {
      val = event.customerGroupName;
    } else {
      val = event.target.value;
    }
    if (exclusionaryNames.includes(val.trim().toLowerCase().replace('\\', ''))) {
      this.setState({ invalidNameUsed: true });
      return 0;
    } else {
      this.setState({ invalidNameUsed: false });
    }
  }

  handleSave = (event) => {

    const { invalidNameUsed } = this.state;

    this.checkCustomerGroupName(event);
    if (invalidNameUsed) return 0;

    let custGroup = '';
    this.setState({ showPrompt: <div />, saving: true });
    if (this.props.data.customerGroups.customerGroups) {
      const { customerGroups } = this.props.data.customerGroups.customerGroups;
      custGroup = customerGroups.filter(e => e.customerGroupId === this.props.match.params.id);
    }

    if (event && custGroup.length === 0) {
      const customerGroup = {
        customerGroupName: removeWhiteSpace(event.customerGroupName),
        customerGroupDesc: removeWhiteSpace(event.customerGroupDesc),
        customerGroupType: removeWhiteSpace(event.customerGroupType)
      };

      if (event.customerGroupId) { custGroup.customerGroupId = event.customerGroupId; }

      this.props.actions.addEditCustomerGroup(customerGroup, this.props.data.config, this);
    } else if (event && custGroup !== '' && event.customerGroupId !== undefined) {
      const customerGroup = {
        customerGroupId: removeWhiteSpace(event.customerGroupId),
        customerGroupName: removeWhiteSpace(event.customerGroupName),
        customerGroupDesc: removeWhiteSpace(event.customerGroupDesc),
        customerGroupType: removeWhiteSpace(event.customerGroupType)
      };
      this.props.actions.addEditCustomerGroup(customerGroup, this.props.data.config, this);
    } else {
      this.setState({ open: true });
    }
  };

  handleClose = (value) => {
    this.setState({ open: false, openDialog: false });
  };

  redirectToUsers = () => {
    let renderDialogForm = <div />;
    if (this.state.redirect) {
      renderDialogForm = (<RenderDialog
        open={this.state.openDialog}
        showActions
        message="Any changes will be lost if you leave this screen. Would you like to continue?"
        onClose={this.handleClose}
        onAgree={this.handleAgree}
      />)
    }
    return renderDialogForm;
  }

  shouldPromptExist = () => {

    if (this.props.match.params.id) {
      const showPrompt = (<Prompt
        when={this.props.dirty}
        message="Any changes will be lost if you leave this screen. Would you like to continue?"
      />);

      this.setState({ showPrompt })
    }
  }

  handleAgree = () => {
    this.props.history.push('/customer-groups');
  }

  saveAlert = () => {
    let dialog = <div />;
    if (this.state.openDialog) {
      dialog =
        (<RenderConfirmationTimeoutDialog
          open={this.state.openDialog}
          stayInAction={() => { this.handleClose(); }}
          handleIdleTimeout={() => { this.handleAgree(); }}
          timeoutInterval={this.props.data.config.ConfirmationTimeout}
          page={this.props.match.params.id ? 'Edit Customer Group' : 'Add Customer Group'}
        />);
    } else {
      dialog = (<div />);
    }
    return dialog;
  }

  render() {
    let dialogBox = <div />;
    const dialog = this.saveAlert();

    if (this.state.open) {
      dialogBox = (<RenderDialog
        open
        confirmButton
        message="Customer group already exists"
        onClose={this.handleClose}
      />);
    }

    const { classes, handleSubmit } = this.props;
    return (
      <Layout
        className="App"
        showMenu
        menuTitle=""
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        {this.state.showPrompt}
        <Paper className={classes.paperStyle}>
          {dialogBox}
          {dialog}
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title" className="lightH2">
                {(this.props.match.params.id) ? 'Edit Customer Group' : 'Add Customer Group'}
              </Typography>
              <IconButton title="close" component={Link} to="/customer-groups">
                <Close color="disabled" />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Form onSubmit={handleSubmit(this.handleSave)}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <Field
                  name="customerGroupName"
                  component={renderTextField}
                  label="*Customer Group Name"
                  className={classes.textField}
                  divClassName={classes.marginStyle}
                  onChange={(event) => { this.checkCustomerGroupName(event); }}
                />
                <div
                  style={(!this.state.invalidNameUsed ?
                    {display: 'none' } :
                    { display: 'block', color: 'red', fontSize: '0.75rem' })}
                  >
                  This is not a valid name
                </div>
              </CardContent>
            </Card>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <Field
                  name="customerGroupDesc"
                  component={renderTextField}
                  label="*Group Description"
                  className={classes.textField}
                  divClassName={classes.marginStyle}
                />
              </CardContent>
            </Card>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <Field
                  name="customerGroupType"
                  component={renderTextField}
                  label="*Group Type"
                  className={classes.textField}
                  divClassName={classes.marginStyle}
                />
              </CardContent>
            </Card>
            <div className={classes.buttonStyle}>
              <Button
                className={classes.buttonSize}
                disabled={!this.props.valid || this.state.saving}
                style={(this.props.valid && !this.state.saving) ? { background: '#002053' } : { background: '#ddd' }}
                variant="raised"
                color="primary"
                type="submit">{this.state.saving ? 'Please wait...' : 'Save'}</Button>
              <div className={`${classes.messageStyle} mandatory-msg`}>* Required fields</div>
            </div>
          </Form>
        </Paper>
      </Layout>
    );
  }
}

AddEditCustomerGroup.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = (state, ownProps) => ({
  data: {
    addEditCustomerGroup: state.addEditCustomerGroup,
    customerGroups: state.customerGroups,
    config: state.config.config,
    formValues: getFormValues('AddEditCustomerGroupForm')(state)
  },
  initialValues: ownProps.match.params.id && state.customerGroups && state.customerGroups.customerGroups ? 
  state.customerGroups.customerGroups.customerGroups.filter(group => group.customerGroupId === ownProps.match.params.id)[0] :
  ''
});

const mapDispatchToProps = dispatch => ({
  actions: {
    addEditCustomerGroup: (customerGroup, config, self) => {
      const selfer = self;
      dispatch(addEditCustomerGroup(customerGroup, config)).then((o) => {
        if (o.action.type === 'ADD_EDIT_CUSTOMER_GROUP_SAVE_FULFILLED') {
          dispatch(getCustomerGroups(config));
          dispatch(searchAllPages('person-locations', config));
          dispatch(searchAllPages('locations', config, true));
          dispatch(getCustomers(config));
          dispatch(searchAllPages('persons', config));
          const userData = {
            id: o.value.data.customerGroupId,
            customerGroupId: o.value.data.customerGroupId,
            customerGroupName: o.value.data.customerGroupName,
            customerGroupDesc: o.value.data.customerGroupDesc,
            customerGroupType: o.value.data.customerGroupType
          };
          self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#002053' });
        }
      });
    }
  }
});


const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
  form: 'AddEditCustomerGroupForm',
  enableReinitialize: true,
  validate
})(AddEditCustomerGroup));

const ConnectedAddEditCustomerGroup = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditCustomerGroup;


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/AddEditCustomerGroup.js